import React from 'react';
import '../../styles/Preloader.css'; // Assuming you have a CSS file for styling the loader
const Preloader = () => (
	<div
		style={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '300px',
			width: '100vw',
			minWidth: '200px',
			maxWidth: '300px',
		}}
	>
		<div className="loader"></div>
	</div>
);

export default Preloader;
